import React from "react"
import withRouter from "../../Common/withRouter"
import PropTypes from "prop-types"

import Sidebar from "./Sidebar"
import Footer from "./Footer"

const Layout = props => {
  function collapsedToggle() {
    var body = document.body
    body.classList.toggle("vertical-collpsed")
  }

  return (
    <React.Fragment>
      <div id="layout-wrapper">
        <Sidebar />
        <div className="condensed-menu" onClick={collapsedToggle}>
          <i className="fa fa-caret-left open-menu" aria-hidden="true" />
          <i className="fa fa-caret-right close-menu" aria-hidden="true" />
        </div>
        <div className="main-content">{props.children}</div>
        <Footer />
      </div>
    </React.Fragment>
  )
}

Layout.propTypes = {
  children: PropTypes.any,
}

export default withRouter(Layout)
